import { nodeApi, nodeApi3 } from "./../config"
import { getTokenNode } from "../../store/utils/tokenNode"

export default {
/*
  register(form) {
    return nodeApi.post("/auth/signup/", {
      name: form.name,
      email: form.email,
      phone: form.phone,
      cpf: form.cpf_cnpj,
      password: form.password,
      pid: form.pid,
    });
  },
  login(username, password) {
    return nodeApi.post("/auth/signin/", {
      username: username,
      password: password
    });
  },
  */
  loginv2(username, password) {
    return nodeApi3.post("/auth/signin/", {
      username: username,
      password: password
    });
  },

  registerV2(form){
    return nodeApi3.post("/auth/signup/", {
      name: form.name,
      email: form.email,
      phone: form.phone,
      cpf: form.cpf_cnpj,
      password: form.password,
      pid: form.pid,
    });
  },

  forgotPassword(email) {
    return nodeApi3.post("/auth/forgot-password/", {
      email: email
    });
  },

  resetPassword(form) {
    return nodeApi3.post("/auth/reset-password/", {
      hashcode: form.hashcode,
      password: form.password,
      confirm_password: form.confirm_password,
    });
  },

  getUserDetails(uuid){
    return nodeApi3.get(`/auth/user-details/?user_uuid=${uuid}`);
  },

  /*
  loginGoogle(authCode, pid) {
    return nodeApi.post("/auth/signin-google/", {
      code: authCode,
      pid: pid
    });
  },
  forgotPassword(user_or_email) {
    return nodeApi.post("/auth/forgotPassword/", {
      user_or_email: user_or_email
    });
  },

  getUserProductsList() {
    if (process.env.NODE_ENV != "production") {
      //Mucugê
      // return JSON.parse('[{"name":"Museu Vivo do Garimpo","localpm":["dinheiro"]},{"name":"Projeto Sempre Viva","localpm":["dinheiro"]}]');
      //PNCD
      // return JSON.parse('[{"name":"Andorinhas, Sete Quedas e Funis","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Calif\u00f3rnia","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeira da Donana","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira da Fuma\u00e7a","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cachoeira da Fuma\u00e7a (por baixo)","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cachoeira da Fumacinha (por cima)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Matinha","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira da Mo\u00e7a Loira","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira das 3 Barras","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira do Bate-palmas","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira do C\u00f3rrego de Pedra","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cachoeira do Ramalho","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Cachoeira do Sossego","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Cachoeira dos Pombos","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeira laranjeira","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Cachoeir\u00e3o por baixo","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Calixto","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cap\u00e3o-\u00c1guas Claras","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Cardoso","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Cascalheira (Planet\u00e1rio)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Castelo","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Circuito Rio Preto-Rodas-Ponte Velha","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Estrada Velha do Garimpo","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Funis","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Gerais do Vieira","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Gruta do Lap\u00e3o","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Mar de Espanha e Cachoeira da Sib\u00e9ria","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Mirante do Cachoeir\u00e3o","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Mirante do Pati","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Po\u00e7o da \u00c1rvore","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Po\u00e7o do Gavi\u00e3o","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Po\u00e7o dos Patos","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"}]},{"name":"Po\u00e7o Redondo (rio Paragua\u00e7u)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Pon\u00e9m-\u00c1guas Claras","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Purifica\u00e7\u00e3o","localpm":null,"category":[{"name":"Palmeiras","slug":"palmeiras"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Rampa do Caim","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Ribeir\u00e3o do Meio","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Rio Preto (at\u00e9 a Toca do Caboclo)","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Rio Preto","localpm":null,"category":[{"name":"Mucug\u00ea","slug":"mucuge"}]},{"name":"Setor calif\u00f3rnia","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Setor coisa boa","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Travessia Cachoeira do 21","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Travessia Cap\u00e3o-Len\u00e7\u00f3is","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"},{"name":"Vale do Cap\u00e3o","slug":"vale-do-capao"}]},{"name":"Trilha Andara\u00ed - Igatu","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Trilha da Cachoeira Capivari e Mixila","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Trilha da Cachoeira do Palmital","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]},{"name":"Trilha da Pedra do Urubu","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"}]},{"name":"Trilha do Capa Bode (Cascalheira-Igatu)","localpm":null,"category":[{"name":"Andara\u00ed","slug":"andarai"},{"name":"Igat\u00fa","slug":"igatu"}]},{"name":"Trilha Fumacinha e V\u00e9u de Noiva","localpm":null,"category":[{"name":"Ibicoara","slug":"ibicoara"}]},{"name":"Trilha Pon\u00e9m-Barro Branco","localpm":null,"category":[{"name":"Len\u00e7\u00f3is","slug":"lencois"}]}]');
      //Ibicoara
      return [{"id":14385,"name":"Cachoeira do Burac\u00e3o","localpm":["credito","debito","pix"],"category":[{"name":"Ibicoara","slug":"ibicoara"}],"commission":{"commission_mode":"percent","commission_value":10,"commission_fixed":""}}]
    } else {
      return nodeApi.get("/poiList/");
    }
  },
  */

  findAllByUserRules() {
    return nodeApi.get("/issues/");
  },

  getRequerimentoById(idRequerimento) {
    return nodeApi.get(`/issues/${idRequerimento}`);
  },

  cadastrarRequerimento(detalhes, tipo) {
    //set user_id_from for test
    return nodeApi.post("/issues/", { details: detalhes, type: tipo });
  },

  getAllStatusRequerimentos() {
    return nodeApi.get("/issuesStatus");
  },

  getAllStatusDocumentos() {
    return nodeApi.get("/filesStatus");
  },

  getDetalhesStatusRequerimento(idStatus) {
    return nodeApi.get(`/issuesStatus/${idStatus}`);
  },

  updateStatusRequerimento(idRequerimento, statusId) {
    return nodeApi.put(`/issues/${idRequerimento}`, { statusId });
  },

  getTiposRequerimentos() {
    return nodeApi.get("/issuesTypes");
  },

  getTiposRequerimentosAtivos() {
    return nodeApi.get("/issuesTypes/actives");
  },

  updateTipoRequerimento(id, label, descricao) {
    return nodeApi.put(`/issuesTypes/${id}`, {
      label: label,
      description: descricao
    });
  },

  deleteTipoRequerimento(id) {
    return nodeApi.delete(`/issuesTypes/${id}`);
  },

  cadastrarTipoRequerimento(label, descricao) {
    return nodeApi.post("/issuesTypes", {
      label: label,
      description: descricao
    });
  },

  getDetalhesTipoRequerimento(tipo) {
    return nodeApi.get(`/issuesTypes/${tipo}`);
  },

  postDocumento(fileInfo, file) {
    return nodeApi.post("/files/create", file, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": getTokenNode()
      },
      params: {
        name: fileInfo.name,
        refId: fileInfo.refId,
        ref: fileInfo.ref,
        status: fileInfo.status,
      }
    });
  },

  updateStatusDocumento(idDocumento, statusId) {
    return nodeApi.put(`/files/${idDocumento}`, { statusId });
  },

  getDocumentos() {
    return nodeApi.get("/files");
  },

  getDocumentosByRequerimentoId(idRequerimento) {
    return nodeApi.get(`/files/${idRequerimento}/files`);
  },

  getFileByPath(filePath) {
    return nodeApi.get(`/files/public/?file_path=${filePath}`, {
      responseType: "blob"
    });
  },

  downloadDocumento(fileId) {
    return nodeApi.get(`/files/download/${fileId}`, {
      responseType: "blob"
    });
  },

  postMessage(message, title, userIdTo, issuesId) {
    return nodeApi.post("/messages", {
      message: message,
      title: title,
      userIdTo: userIdTo,
      issuesId,
      issuesId
    });
  },

  getMessagesByIssuesId(issuesId) {
    return nodeApi.get(`/messages/issues/${issuesId}`);
  },

  deleteProduct(product_id) {
    return nodeApi.delete(`/products/${product_id}`);
  },

  /**
   *
   *    Node.js API 2.0
   *
  */

  /**
   *
   * @returns JSON list off all withdraws from current user
   */
  getWithdraws(startDate, endDate, refreshCache) {
    let url = '/withdraw'
    if(refreshCache == true){
      url += '?nocache=true'
    }
    return nodeApi3.get(url, {
      start_date: startDate,
      end_date: endDate,
    });
  },

  /**
   * Insere registro de solicitação de retirada de saldo
   *
   * @param {*} orders
   * @param {*} value
   * @returns
   */
  saveWithdraw(orders, value) {
    return nodeApi3.post('/withdraw', {
      orders: orders,
      value: value
    });
  },

  /**
   * Gera novo Bearer Token para Iframe Getnet
   *
   * @returns
   */
  createGetnetToken() {
    return nodeApi3.post('/getnet/token');
  },


  /**
   * Gera novo Bearer Token para Iframe Getnet
   *
   * @returns
   */
  createGetnetQRPix(form) {
    return nodeApi3.post('/getnet/generate-qr-code-pix', form);
  },

  /**
   * Carrega lista de entradas de dados do Trafx por date e uuid do usuário logado
   *
   * @param {*} form
   * @returns
   */
  getTrafxEntries(form) {
    return nodeApi3.get('/trafx/entries'
    +"?uuid_gestor=" + form.UUID
    +'&start_date=' + form.start_date +
    "&end_date=" + form.end_date
    );
  },

  /**
   * Carrega lista de arquivos upados do Trafx
   *
   * @returns JSON com detalhes de cada arquivo
   */
  getTrafxFiles() {
    return nodeApi3.get('/trafx');
  },

  /**
   * Insere registros de dados Trafx
   *
   * @param {*} form
   * @returns
   */
  saveTrafx(form) {
    return nodeApi3.post('/trafx', form);
  },

  /**
   * Carrega uma lista de produtos de uma determinada categoria
   * @todo permitir parâmetro de definição da categoria
   * @param {*} formDate
   * @returns
   */
  getOperations(formDate) {
    var cat = 'Roteiro'
    return nodeApi3.get('/bills/products?cat='
      + cat +
      '&sdate=' + formDate.startDate +
      '&edate=' + formDate.endDate
    );
  },


  /**
   * Carrega os detalhes de uma reserva e informações pertinentes a ela
   * @param {String} UUID
   * @returns {*}
   */
  getBookingByUUID(UUID){
    return nodeApi3.get(`/janoowp/bookingsUuid?hash=${UUID}`)
  },

  /**
   * Carrega uma lista de itens de venda (Janoo) no período determinado
   * @param {*} formDate
   * @returns
   */
  getWPItems(params) {
    return nodeApi3.get(`/janoowp/bookings?start_date=${params.startDate}&end_date=${params.endDate}&bill_items_response=ok&operation_request=${params.operation_request}`);
  },

  /**
   * Carrega uma lista de itens de venda (banco) no período determinado
   * @param {*} formDate
   * @returns
   */
  getBillItems(params) {
    let $nocache = ''
    let code = ''
    if(params.startDate >= (new Date()).toISOString().substring(0,10)){
      $nocache = '&nocache='+(new Date()).getTime()
    }

    if(params.code){
      code = `&code=${params.code}`
    }

    return nodeApi3.get(`/booking/byPeriod?start_date=${params.startDate}&end_date=${params.endDate}${$nocache}${code}`);
  },

  /**
  * Cria uma reserva expressa correspondente a uma registrada na Getnet
  * @param {*} form
  * @returns
  */
  postCreateExpressBookingGetnet(form){
    return nodeApi3.post(process.env.VUE_APP_GETNET_URL_CALLBACK, form)
  },

  /**
  * Cria uma reserva expressa correspondente a uma registrada no Mercado Pago
  * @param {*} form
  * @returns
  */
  postCreateExpressBookingMercadoPago(form){
    return nodeApi3.post(process.env.VUE_APP_MERCADO_PAGO_URL_CALLBACK, form)
  },

  /**
   * Adiciona condutores a uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postAddBookingAgent(payload){
    return nodeApi3.post("/booking/event", {
      "action": "booking_add_agent_handler",
      "hash": payload.hash,
      "payload": payload.agents,
    })
  },

  /**
   * Remove condutor de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postRemoveBookingAgent(payload){
    return nodeApi3.post("/booking/event", {
      "action": "booking_remove_agent_handler",
      "hash": payload.hash,
      "payload": {uuid: payload.uuid},
    })
  },

  /**
   * Realiza checkin de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postCheckinExpressBooking(payload){
    return nodeApi3.post("/booking/event", {
      "action": "booking_checked_in_handler",
      "hash": payload.hash,
      "payload": {
        "keepdate": true,
      },
    })
  },

  /**
   * Realiza o cancelamento de uma reserva expressa
   * @param {*} payload
   * @returns
   */
  postCancelExpressBooking(payload){
    return nodeApi3.post("/booking/event", {
      "action": "booking_complete_to_cancelled_handler",
      "hash": payload.hash,
    })
  },

  /**
   * Realiza a mudança de quantidade de pessoas de uma reserva
   * @param {*} payload
   * @returns
   */
    postUpdateExpressBookingTickets(payload){
      return nodeApi3.post("/booking/event", {
        action: "booking_update_quantity_visitors",
        hash: payload.hash,
        payload: {
          tickets: payload.indexes,
          message: payload.message,
          to_wallet: payload.pixRefund == 'wallet',
          refund_type: payload.pixRefund,
          pix_code: payload.pix_code
        },
      })
    },

  /**
   * Realiza a troca de dadta de de uma reserva
   * @param {*} payload
   * @returns
   */
    postUpdateExpressBookingDate(payload){
      return nodeApi3.post("/booking/event", {
        "action": "booking_date_changed_handler",
        "hash": payload.hash,
        "payload": {
          "date": payload.date,
        },
      })
    },

    /**
     * Realiza o bloqueio de reservas de determinada data
     * @param {*} payload
     * @returns
     */
    postBlockDayProduct(payload){
      return nodeApi3.post(`/products/updateUnavailability`,{
        product_uuid: payload.product_uuid,
        unavailability: payload.unavailability,
      })
    },

    /**
     * Realiza o desbloqueio de reservas de determinada data
     * @param {*} payload
     * @returns
     */
    postUnblockDayProduct(payload){
      return nodeApi3.post(`/products/updateUnavailability`,{
        action: "remove",
        product_uuid: payload.product_uuid,
        unavailability: payload.unavailability,
      })
    },

  /**
   * Cria/Edita uma nova transação
   * @param {*} payload
   * @returns
   */
  postTransaction(payload){
    let endpoint = `/finance`

    if(payload.general.id > 0){
      endpoint = `/finance/${payload.general.id}`
      return nodeApi3.put(endpoint, payload)
    }
    else{
      return nodeApi3.post(endpoint, payload)
    }
  },

  /**
   * Carrega uma transação pelo PID
   * @param {*} payload
   * @returns
   */
  getTransactionById(payload){
    return nodeApi3.get(`/finance/`+ payload.pid, {
      type: payload.type,
    })
  },


  /**
   * Carrega uma lista de itens do relatório de entradas financeiras
   * @param {*} formDate
   * @returns
   */
  getFinanceBookingReportData(params) {
    return nodeApi3.get(`/finance/report/booking?startDate=${params.startDate}&endDate=${params.endDate}`);
  },


  /**
   * Dispara para servidor enviar mensagem via Whatsapp
   *
   * @param {*} message
   * @returns
   */
  postWhatsappMessage(message) {
    return nodeApi3.post('/messenger/send-whatsapp', {
      typeMessage: message.typeMessage,
      messageBody: message.messageBody
    });
  },
  /**
   * Agenda mensagem para Whatsapp
   *
   * @param {*} message
   * @returns
   */
  scheduleWhatsappMessage(message) {
    let endpoint = '/messenger/schedule'
    return nodeApi3.post(endpoint, [message]);
  },

  /**
   * Carrega lista de produtos do vendedor (POIs)
   *
   * @param {*} vendor_uuid
   * @returns
   */
  getPoisByVendor(payload){
    return nodeApi3.get('/products/poi/?place_uuid=' + payload.PLACE_UUID + '&product_uuid=' + payload.PRODUCT_UUID)
  },

  /**
   * Carrega lista de produtos do vendedor (atrativos)
   *
   * @param {*} vendor_uuid
   * @returns
   */
  getProductsByVendor(vendor_uuid){
    return nodeApi3.get('/products/gestor/?vendor_uuid=' + vendor_uuid)
  },

  /**
   * Carrega produtos pelo UUID
   *
   * @param {*} vendor_uuid
   * @returns
   */
  getProduct(product_uuid){
    return nodeApi3.get('/products/?product_uuid=' + product_uuid)
  }

};
